import { useNavigate, useLocation } from "react-router-dom";
import { Crosshair, Home, BookOpen, ArrowLeft } from "lucide-react";

export default function Navbar({ currentProject, onNavigateHome }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isEditor = location.pathname.startsWith("/editor/");
  const isTermbase = location.pathname.startsWith("/termbase/");

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 h-14 flex items-center justify-between px-6 border-b border-[#2A2F3A] bg-[#0A0B10]/90 backdrop-blur-md"
      data-testid="navbar"
    >
      <div className="flex items-center gap-4">
        <button
          onClick={onNavigateHome}
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <Crosshair className="w-5 h-5 text-neon-cyan" strokeWidth={1.5} />
          <span className="font-heading font-bold text-lg tracking-wider uppercase text-[#E0E0E0] group-hover:text-neon-cyan transition-colors duration-200">
            Neon Operator
          </span>
        </button>

        {currentProject && !isHome && (
          <div className="flex items-center gap-2 ml-4">
            <span className="text-[#64748B] text-sm">/</span>
            <span className="text-[#94A3B8] text-sm font-ui truncate max-w-[200px]">
              {currentProject.name}
            </span>
          </div>
        )}
      </div>

      <div className="flex items-center gap-1">
        <div className="flex items-center gap-2 mr-3 px-3 py-1 rounded-sm bg-surface-300/50 border border-[#2A2F3A]">
          <div className="w-1.5 h-1.5 rounded-full bg-neon-green shadow-[0_0_6px_#39FF14]" />
          <span className="text-xs font-mono text-[#94A3B8]" data-testid="nav-username">fanzhang</span>
        </div>
        {!isHome && (
          <button
            onClick={onNavigateHome}
            className="flex items-center gap-2 px-3 py-1.5 rounded-sm text-[#94A3B8] hover:text-[#E0E0E0] hover:bg-white/5 transition-colors duration-200 text-sm font-ui"
            data-testid="nav-home-btn"
          >
            <Home className="w-4 h-4" strokeWidth={1.5} />
            <span className="hidden sm:inline">Dashboard</span>
          </button>
        )}

        {currentProject && isEditor && (
          <button
            onClick={() => navigate(`/termbase/${currentProject.id}`)}
            className="flex items-center gap-2 px-3 py-1.5 rounded-sm text-[#94A3B8] hover:text-[#E0E0E0] hover:bg-white/5 transition-colors duration-200 text-sm font-ui"
            data-testid="nav-termbase-btn"
          >
            <BookOpen className="w-4 h-4" strokeWidth={1.5} />
            <span className="hidden sm:inline">Term Base</span>
          </button>
        )}

        {currentProject && isTermbase && (
          <button
            onClick={() => navigate(`/editor/${currentProject.id}`)}
            className="flex items-center gap-2 px-3 py-1.5 rounded-sm text-[#94A3B8] hover:text-[#E0E0E0] hover:bg-white/5 transition-colors duration-200 text-sm font-ui"
            data-testid="nav-editor-btn"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            <span className="hidden sm:inline">Editor</span>
          </button>
        )}
      </div>
    </nav>
  );
}
